// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__216yy","colMin":"styles_colMin__1Vjl2"};